import React, { useEffect, useState } from "react";
import axiosInstance from "../../../axiosInstance";
import { Link, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const EditHomeCategory = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  // Parent category options
  const [cats, setCats] = useState([]);
  const [catsLoading, setCatsLoading] = useState(true);
  const [faqs, setFaqs] = useState([{ title: "", description: "" }]);

  // Form + UI state
  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    para: "",
    description: "",
    metaTitle: "",
    metaDescription: "",
    metaKeywords: "",
    parent: "",
    icon_image: "",
    status: 1, // Number (1 active, 0 inactive)
    auth: 0,   // Number (0/1)
    link: "",
    authLink: "",
  });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [showCode, setShowCode] = useState(true);
  // ---- NEW: FAQs state

  const addFaq = () =>
    setFaqs((arr) => [...arr, { title: "", description: "" }]);

  const removeFaq = (idx) =>
    setFaqs((arr) => arr.filter((_, i) => i !== idx));

  const handleFaqChange = (idx, field, val) =>
    setFaqs((arr) => {
      const copy = [...arr];
      copy[idx] = { ...copy[idx], [field]: val };
      return copy;
    });


  // Fetch parents
  useEffect(() => {
    const fetchParents = async () => {
      try {
        const res = await axiosInstance.get(`/all-home-category?id=${slug}`);
        setCats(res?.data?.categories || []);
      } catch (e) {
        console.error(e);
        toast.error("Failed to load parent categories.");
      } finally {
        setCatsLoading(false);
      }
    };
    fetchParents();
  }, []);

  // Fetch category by slug
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        // If your API is /admin/get-category/:slug, swap the URL below.
        const { data } = await axiosInstance.get(`/admin/get-home-category/${slug}`);
        const cat = data?.Category || data?.category || {};

        setFormData({
          title: cat.title || "",
          slug: cat.slug || "",
          para: cat.para || "",
          description: cat.description || "",
          metaTitle: cat.metaTitle || "",
          metaDescription: cat.metaDescription || "",
          metaKeywords: cat.metaKeywords || "",
          parent: cat.parent || "",
          icon_image: cat.icon_image || "",
          status: typeof cat.status === "number" ? cat.status : (cat.status ? 1 : 0),
          auth: typeof cat.auth === "number" ? cat.auth : (cat.auth ? 1 : 0),
          link: cat.link || "",
          authLink: cat.authLink || "",
            faqs: cat.faqs,
      price: cat.price,
      heading: cat.heading,
      mission: cat.mission,
      vision: cat.vision,
      price: cat.price,
        });

          setFaqs(cat.faqs ?? []);

      } catch (err) {
        console.error(err);
        toast.error("Failed to fetch category.");
      } finally {
        setLoading(false);
      }
    };
    fetchCategory();
  }, [slug]);

  
  // Handlers
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "slug") {
      const cleaned = value
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
      setFormData((p) => ({ ...p, slug: cleaned }));
      return;
    }

    if (name === "status" || name === "auth") {
      setFormData((p) => ({ ...p, [name]: Number(value) }));
      return;
    }

    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleDescriptionChange = (val) =>
    setFormData((p) => ({ ...p, description: val }));

  const toggleShowCode = () => setShowCode((s) => !s);

  const submitData = async () => {
    // Basic validation
    if (!formData.title.trim()) return toast.error("Title is required.");
    if (!formData.slug.trim()) return toast.error("Slug is required.");

    const payload = {
      title: formData.title.trim(),
      slug: formData.slug,
      para: formData.para,
      description: formData.description,
      metaTitle: formData.metaTitle,
      metaDescription: formData.metaDescription,
      metaKeywords: formData.metaKeywords,
      parent: formData.parent || null,
      icon_image: formData.icon_image || "",
      status: Number(formData.status) || 0,
      auth: Number(formData.auth) || 0,
      link: formData.link,
      authLink: formData.authLink,
      faqs: faqs,
      price: formData.price,
      heading: formData.heading,
      mission: formData.mission,
      vision: formData.vision,
      price: formData.price,
    };

    setSubmitting(true);
    try {
      // If your API is /admin/update-category/:slug, swap the URL below.
      await axiosInstance.put(`/admin/update-home-category/${slug}`, payload);
      toast.success("Category updated successfully!");
      navigate("/all-home-category");
    } catch (err) {
      console.error(err);
      const msg =
        err?.response?.data?.message || err?.message || "Failed to update.";
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />

        <div className="py-4">
          <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
              <li className="breadcrumb-item">
                <a href="#">
                  <svg
                    className="icon icon-xxs"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                </a>
              </li>
              <li className="breadcrumb-item">
                <a href="#">Admin</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Edit Home Category
              </li>
            </ol>
          </nav>

          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4">Edit Home Category</h1>
            </div>
            <div>
              <Link
                to="/all-home-category"
                id="goBackButton"
                className="btn btn-primary d-inline-flex align-items-center"
              >
                <svg
                  style={{ transform: "rotate(180deg)" }}
                  className="icon icon-sm"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Go back
              </Link>
            </div>
          </div>
        </div>

        <form onSubmit={(e) => e.preventDefault()} id="edit-home-category-form">
          <div className="row">
            {/* LEFT */}
            <div className="col-md-8 mb-4">
              <div className="card border-0 shadow components-section">
                <div className="card-body">
                  {loading ? (
                    <p>Loading…</p>
                  ) : (
                    <div className="row mb-4">
                      <div className="col-lg-12 col-sm-12">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-4">
                              <label htmlFor="title">Name</label>
                              <input
                                type="text"
                                className="form-control"
                                id="title"
                                value={formData.title}
                                name="title"
                                onChange={handleChange}
                                placeholder="Enter category name"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-4">
                              <label htmlFor="parent">Parent category</label>
                              <select
                                className="form-control select"
                                name="parent"
                                value={formData.parent || ""}
                                onChange={handleChange}
                                id="parent"
                              >
                                <option value="">None</option>
                                {catsLoading ? (
                                  <option>Loading...</option>
                                ) : (
                                  cats.map((c) => (
                                    <option key={c._id || c.id} value={c._id}>
                                      {c.title}
                                    </option>
                                  ))
                                )}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-4">
                              <label htmlFor="slug">Slug</label>
                              <input
                                type="text"
                                className="form-control"
                                id="slug"
                                value={formData.slug}
                                name="slug"
                                onChange={handleChange}
                                placeholder="auto-format: my-category"
                              />
                            </div>
                          </div>

      <div className="col-md-6">
                            <div className="mb-4">
                              <label htmlFor="slug">Price</label>
                              <input
                                type="number"
                                className="form-control"
                                id="price"
                                value={formData.price}
                                name="price"
                                onChange={handleChange}
                                placeholder="Add Price"
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="mb-4">
                              <label htmlFor="para">Short Description (para)</label>
                              <textarea
                                className="form-control"
                                value={formData.para}
                                rows="3"
                                name="para"
                                id="para"
                                onChange={handleChange}
                                placeholder="Optional short blurb shown with icon"
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="mb-4">
                              <label
                                htmlFor="description"
                                className="d-flex align-items-center justify-content-between"
                              >
                                Description
                                <button
                                  onClick={toggleShowCode}
                                  className="btn btn-secondary btn-sm"
                                  type="button"
                                >
                                  {showCode ? "Show Editor" : "Show Code"}
                                </button>
                              </label>

                              {showCode ? (
                                <textarea
                                  className="form-control bg-dark text-white"
                                  value={formData.description}
                                  onChange={(e) => handleDescriptionChange(e.target.value)}
                                  rows={6}
                                  style={{ lineHeight: "1.7em" }}
                                />
                              ) : (
                                <ReactQuill
                                  value={formData.description}
                                  onChange={handleDescriptionChange}
                                  modules={{
                                    toolbar: [
                                      [{ header: "1" }, { header: "2" }, { font: [] }],
                                      [{ size: [] }],
                                      ["bold", "italic", "underline", "strike", "blockquote"],
                                      [{ list: "ordered" }, { list: "bullet" }],
                                      ["link"],
                                      ["clean"],
                                    ],
                                  }}
                                  formats={[
                                    "header",
                                    "font",
                                    "size",
                                    "bold",
                                    "italic",
                                    "underline",
                                    "strike",
                                    "blockquote",
                                    "list",
                                    "bullet",
                                    "link",
                                  ]}
                                  bounds=".app"
                                />
                              )}
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="mb-4">
                              <label htmlFor="icon_image">Category Icon (URL)</label>
                              <input
                                type="text"
                                className="form-control"
                                id="icon_image"
                                value={formData.icon_image}
                                name="icon_image"
                                onChange={handleChange}
                                placeholder="https://…"
                              />
                            </div>
                          </div>
                        </div>

                      <hr/>
                      
                                              <div className="col-md-12">
                                                <div className="mb-4">
                                                  <label htmlFor="heading">Heading</label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    id="heading"
                                                    value={formData.heading}
                                                    name="heading"
                                                    onChange={handleChange}
                                                    placeholder="heading"
                                                  />
                                                </div>
                                              </div>
                      
                                            <div className="col-md-12">
                                              <div className="mb-4">
                                                <label htmlFor="icon_image">Category Icon</label>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="icon_image"
                                                  value={formData.icon_image}
                                                  name="icon_image"
                                                  onChange={handleChange}
                                                />
                                              </div>
                                            </div>
                      
                                            {/* ===================== */}
                                            {/*       FAQs AREA       */}
                                            {/* ===================== */}
                      
                                               <div className="col-md-12">
                                              <div className="mb-4">
                                                <label htmlFor="mission">Category MISSION</label>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="mission"
                                                  value={formData.mission}
                                                  name="mission"
                                                  onChange={handleChange}
                                                />
                                              </div>
                                            </div>
                      
                      
                        <div className="col-md-12">
                                              <div className="mb-4">
                                                <label htmlFor="vision">Category VISION</label>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="vision"
                                                  value={formData.vision}
                                                  name="vision"
                                                  onChange={handleChange}
                                                />
                                              </div>
                                            </div>
                      
                      
                      
                                            <div className="mt-2">
                                              <label className="d-block fw-semibold mb-2">
                                                FAQs (optional)
                                              </label>
                      
                                              {faqs.map((f, idx) => (
                                                <div key={idx} className="border rounded p-3 mb-3">
                                                  <div className="mb-2">
                                                    <label className="mb-1">Question</label>
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={f.title}
                                                      onChange={(e) =>
                                                        handleFaqChange(idx, "title", e.target.value)
                                                      }
                                                      placeholder="e.g., How do I earn 60% profit?"
                                                    />
                                                  </div>
                      
                                                  <div className="mb-2">
                                                    <label className="mb-1">Answer</label>
                                                    <ReactQuill
                                                      value={f.description}
                                                      onChange={(val) =>
                                                        handleFaqChange(idx, "description", val)
                                                      }
                                                      modules={{
                                                        toolbar: [
                                                          [{ header: "1" }, { header: "2" }],
                                                          ["bold", "italic", "underline"],
                                                          [{ list: "ordered" }, { list: "bullet" }],
                                                          ["link"],
                                                          ["clean"],
                                                        ],
                                                      }}
                                                      formats={[
                                                        "header",
                                                        "bold",
                                                        "italic",
                                                        "underline",
                                                        "list",
                                                        "bullet",
                                                        "link",
                                                      ]}
                                                    />
                                                  </div>
                      
                                                  {faqs.length > 1 && (
                                                    <button
                                                      type="button"
                                                      className="btn btn-danger btn-sm"
                                                      onClick={() => removeFaq(idx)}
                                                    >
                                                      Remove FAQ
                                                    </button>
                                                  )}
                                                </div>
                                              ))}
                      
                                              <button
                                                type="button"
                                                className="btn btn-secondary btn-sm"
                                                onClick={addFaq}
                                              >
                                                + Add another FAQ
                                              </button>
                                            </div>
                                            {/* ===================== */}
                      

                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-4">
                              <label htmlFor="metaTitle">Meta Title</label>
                              <input
                                type="text"
                                className="form-control"
                                id="metaTitle"
                                value={formData.metaTitle}
                                name="metaTitle"
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="mb-4">
                              <label htmlFor="metaDescription">Meta Description</label>
                              <textarea
                                className="form-control"
                                rows="3"
                                name="metaDescription"
                                id="metaDescription"
                                value={formData.metaDescription}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="mb-4">
                              <label htmlFor="metaKeywords">Meta Keywords</label>
                              <textarea
                                className="form-control"
                                rows="3"
                                value={formData.metaKeywords}
                                name="metaKeywords"
                                id="metaKeywords"
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Links & Auth */}
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-4">
                              <label htmlFor="link">Public Link</label>
                              <input
                                type="text"
                                className="form-control"
                                id="link"
                                value={formData.link}
                                name="link"
                                onChange={handleChange}
                                placeholder="https://example.com/page"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-4">
                              <label htmlFor="auth">Auth Required?</label>
                              <div className="d-flex gap-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="auth"
                                    id="auth_no"
                                    value={0}
                                    onChange={handleChange}
                                    checked={Number(formData.auth) === 0}
                                  />
                                  <label className="form-check-label" htmlFor="auth_no">
                                    No
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="auth"
                                    id="auth_yes"
                                    value={1}
                                    onChange={handleChange}
                                    checked={Number(formData.auth) === 1}
                                  />
                                  <label className="form-check-label" htmlFor="auth_yes">
                                    Yes
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          {Number(formData.auth) === 1 && (
                            <div className="col-md-12">
                              <div className="mb-4">
                                <label htmlFor="authLink">Auth Link</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="authLink"
                                  value={formData.authLink}
                                  name="authLink"
                                  onChange={handleChange}
                                  placeholder="https://example.com/protected"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* RIGHT */}
            <div className="col-md-4 mb-4">
              <div className="card border-0 shadow components-section">
                <div className="card-body">
                  <div className="row">
                    <div className="col-4">
                      <div className="mb-2">
                        <label className="my-1 me-2" htmlFor="status">
                          Status
                        </label>
                      </div>
                    </div>

                    <div className="col-8">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="status"
                          id="status_active"
                          value={1}
                          onChange={handleChange}
                          checked={Number(formData.status) === 1}
                        />
                        <label className="form-check-label text-success" htmlFor="status_active">
                          Active
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="status"
                          id="status_inactive"
                          value={0}
                          onChange={handleChange}
                          checked={Number(formData.status) === 0}
                        />
                        <label className="form-check-label text-danger" htmlFor="status_inactive">
                          Inactive
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 mt-3">
                    {!submitting ? (
                      <button
                        className="btn btn-secondary"
                        type="button"
                        onClick={submitData}
                      >
                        Update Category
                      </button>
                    ) : (
                      <button className="btn btn-secondary btn-sm" type="button" disabled>
                        <span className="ms-1">Saving...</span>
                        <span
                          className="spinner-border spinner-border-sm ms-2"
                          role="status"
                          aria-hidden="true"
                        />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* /RIGHT */}
          </div>
        </form>
      </main>
    </>
  );
};

export default EditHomeCategory;
